import { queryOptions } from '@tanstack/react-query';

import { getProductById } from './api';

import { PRODUCT_BY_ID } from '@/modules/ReactQuery/cacheKeys';

export const UNAUTHENTICATED_USER_ID = 'UNAUTHENTICATED';

export function buildProductByIdForUserQueryOptions({
  productId,
  userId = UNAUTHENTICATED_USER_ID,
  includeOffers,
  includeSellerInfo,
  sessionId,
}: {
  productId?: string;
  userId?: number | typeof UNAUTHENTICATED_USER_ID;
  includeOffers?: boolean;
  includeSellerInfo?: boolean;
  sessionId?: string | null;
}) {
  return queryOptions({
    queryKey: [
      PRODUCT_BY_ID,
      productId,
      userId,
      { includeOffers, includeSellerInfo },
    ],
    queryFn: () =>
      getProductById({
        sessionId,
        productId: productId as string,
        include_offers: includeOffers,
        include_seller_info: includeSellerInfo,
      }),
  });
}
